import React, { useEffect,useState, useMemo } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
} from "react-bootstrap-table2-paginator";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../../../_redux/countries/countriesActions";
import * as crud from "../../../_redux/countries/countriesCrud";

import * as uiHelpers from "../CountriesUIHelpers";
import {
  getSelectRow,
  getHandlerTableChange,
  NoRecordsFoundMessage,
  PleaseWaitMessage,
  sortCaret,
} from "../../../../../../_metronic/_helpers";
import * as columnFormatters from "./column-formatters";
import { getRowStyleByStatus } from "../../../_helpers/tableRowStatusColors";
import { Pagination } from "../../../../../../_metronic/_partials/controls";
import { useCountriesUIContext } from "../CountriesUIContext";

export function CountriesTable() {
  const {user} = useSelector(state => state.auth);
  const userobject = user.userData;
  var superadmin = true;
  if (userobject.admin_role && userobject.admin_role !== 'superadmin' && userobject.is_admin) { superadmin = false; }

  // Countries UI Context
  const countriesUIContext = useCountriesUIContext();
  const countriesUIProps = useMemo(() => {
    return {
      ids: countriesUIContext.ids,
      setIds: countriesUIContext.setIds,
      queryParams: countriesUIContext.queryParams,
      setQueryParams: countriesUIContext.setQueryParams,
      openEditCountryPage: countriesUIContext.openEditCountryPage,
      openDeleteCountryDialog: countriesUIContext.openDeleteCountryDialog,
    };
  }, [countriesUIContext]);

  // Getting curret state of countries list from store (Redux)
  const { currentState } = useSelector(
    (state) => ({ currentState: state.countries }),
    shallowEqual
  );

  const delay = ms => new Promise(res => setTimeout(res, ms));

  const { totalCount, entities, listLoading } = currentState;
  const [processing, setProcessing] = useState('');
  const [isEdit, setisEdit] = useState('');
  const [nameValue, setNameValue] = useState('');

  // Countries Redux state
  const dispatch = useDispatch();

  const updateStatus = async (id, status) => {
    setProcessing(id);
    await crud.updateStatusForCountry(id, status);
    dispatch(actions.fetchCountries(countriesUIProps.queryParams));
    setProcessing('');
  };
  const isApprovalTab = ["approved", "pending", "rejected"].includes(window.location.pathname.split("/")[2]);
  const rowStyle = (row) => getRowStyleByStatus(row, isApprovalTab ? 'approval_status' : 'status');

  const editCountry = async (row) => {
    setisEdit(row.id);
    setNameValue(row.name);
  };
  
  const saveCountry = async (row) => {
    setProcessing("save" + row.id);
    await crud.updateRecordForCountry(row.id, nameValue);
    dispatch(actions.fetchCountries(countriesUIProps.queryParams));
    setisEdit('');
    setProcessing('');
  };

  useEffect(() => {
    // clear selections list
    countriesUIProps.setIds([]);
    // server call by queryParams
    dispatch(actions.fetchCountries(countriesUIProps.queryParams));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [countriesUIProps.queryParams, dispatch]);
  // Table columns
  let columns = [
    {
      attrs: { title: 'Name' },
      dataField: "name",
      text: "Name",
      formatter: columnFormatters.NameColumnFormatter,
      formatExtraData: {
        isEdit: isEdit,
        setNameValue: setNameValue,
        nameValue: nameValue,
      },
      sort: true,
      sortCaret: sortCaret,
    },
    {
      attrs: { title: 'Status' },
      dataField: "status",
      text: "Status",
      formatter: columnFormatters.StatusColumnFormatter,
      formatExtraData: {
        updateStatus: updateStatus,
        superadmin: superadmin,
        processing: processing,
      },
      sort: true,
      sortCaret: sortCaret,
    },
  ];


  if(superadmin)
  {
    columns.push({
      attrs: { title: 'Actions' },
      dataField: "action",
      text: "Actions",
      formatter: columnFormatters.ActionsColumnFormatter,
      formatExtraData: {
        editCountry:editCountry,
        saveCountry:saveCountry,
        isEdit:isEdit,
        processing:processing,
        setisEdit:setisEdit,
      },
      
      style: {
        minWidth: "100px",
      },
    })
  }
  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: countriesUIProps.queryParams.pageSize,
    page: countriesUIProps.queryParams.pageNumber,
  };
  return (
    <>
      <PaginationProvider pagination={paginationFactory(paginationOptions)}>
        {({ paginationProps, paginationTableProps }) => {
          return (
            <Pagination
              isLoading={listLoading}
              paginationProps={paginationProps}
            >
              <BootstrapTable
                wrapperClasses="table-responsive"
                classes="custom-res-table table table-head-custom table-head-bg table-vertical-center"
                bootstrap4
                bordered={false}
                remote
                keyField="id"
                data={entities === null ? [] : entities}
                columns={columns}
                defaultSorted={uiHelpers.defaultSorted}
                rowStyle={ rowStyle } 
                onTableChange={getHandlerTableChange(
                  countriesUIProps.setQueryParams
                )}
                selectRow={getSelectRow({
                  entities,
                  ids: countriesUIProps.ids,
                  setIds: countriesUIProps.setIds,
                })}
                {...paginationTableProps}
              >
                <PleaseWaitMessage entities={entities} />
                <NoRecordsFoundMessage entities={entities} />
              </BootstrapTable>
            </Pagination>
          );
        }}
      </PaginationProvider>
    </>
  );
}
